import { FC } from 'react';
import { ContentLoader } from '@edikk-edikk/country-common';
import { MetaData } from '@edikk-edikk/country-frontend';
import { Background } from '#home/components';
import { Content } from '#home/components/Content';
import homeCss from '#srcCssModules/home/home.module.scss';
import { useApi } from '#hooks/use-api';
import { HomeContext, HomeContextType } from '#home/contexts';

const Home: FC = () => {
  const api = useApi();
  const { data, isFetching } = api.getApiHome().useInitQuery();

  if (isFetching) {
    return <ContentLoader />;
  }

  const homeContextValue: HomeContextType = {
    seo: data.seo,
    popularCityList: data.popularCityList,
    mainImageUrl: data.mainImageUrl,
    mainCity: data.mainCity,
    advertList: data.advertList,
  };

  return (
    <HomeContext value={homeContextValue}>
      <div className={homeCss.home}>
        <MetaData seo={data.seo} />
        <Background />
        <Content />
      </div>
    </HomeContext>
  );
};

export default Home;
